import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from "axios";
import "flatpickr/dist/flatpickr.css";
import config, { GETCATEGORIES } from "../../Common/Configurations/APIConfig";
import { handleSuccess, handleError } from "../../Common/Layout/CustomAlerts";
import LayoutHeader from "../../Common/Layout/Header";
import LayoutSideBar from "../../Common/Layout/Sidebar";
import moment from "moment";
import { Modal, Button } from "react-bootstrap";
const initialFieldValues = {
  staffId: "00000000-0000-0000-0000-000000000000",
  designationId: "00000000-0000-0000-0000-000000000000",
  idNumber: "",
  staffName: "",
  phoneNumber: "",
  joiningDate: "",
  email: "",
  address: "",
  isActive: "",
};
export default function Staff() {
  const [lists, setLists] = useState([]);
  const [values, setValues] = useState(initialFieldValues);
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [btnSubmit, setBtnSubmit] = useState(true);
  const [totalPages, setTotalPages] = useState(0);
  const [pageSize, setPageSize] = useState(20);
  const [errors, setErrors] = useState({});
  const [pageNumber, setPageNumber] = useState(1);
  const [data, setData] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [designations, setDesignations] = useState([]);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [staffDetail, setStaffDetail] = useState({});
  const [showAddStaffModal, setShowAddStaffModal] = useState(false);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [userCompanyId, setUserCompanyId] = useState("");
  const userId = localStorage.getItem("userId");
  const headerconfig = {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("userToken"),
    },
  };
  useEffect(() => {
    if (recordForEdit !== null) {
      setValues({
        ...recordForEdit,
        joiningDate: moment(recordForEdit.joiningDate).format("YYYY-MM-DD"),
      });
    }
  }, [recordForEdit]);
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: value,
    });
  };
  const resetForm = () => {
    setValues(initialFieldValues);
    setErrors({});
  };
  const showEditDetails = (data) => {
    setRecordForEdit(data);
    setShowAddStaffModal(true);
  };
  const closeAddStaffModal = () => {
    setShowAddStaffModal(false);
    resetForm();
    setRecordForEdit(null);
  };
  const handleClearSearch = () => {
    setSearchKeyword("");
    GetData(pageNumber);
  };
  const showViewDetails = (data) => {
    setStaffDetail(data);
    setShowDetailModal(true);
  };
  const GetPageData = (number) => {
    if (number >= 1 && number <= totalPages) {
      setPageNumber(number);
      GetData(number);
    }
  };
  const pageNumbers = [];
  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(i);
  }
  const renderPageNumbers = pageNumbers.map((number) => {
    return (
      <li
        className="page-item"
        key={number}
        id={number}
        onClick={() => GetPageData(number)}
      >
        <Link className="page-link">{number}</Link>
      </li>
    );
  });
  const validate = () => {
    let temp = {};
    temp.designationId =
      values.designationId === "00000000-0000-0000-0000-000000000000"
        ? false
        : true;
    temp.idNumber = values.idNumber === "" ? false : true;
    temp.staffName = values.staffName === "" ? false : true;
    temp.phoneNumber = values.phoneNumber === "" ? false : true;
    temp.email = values.email === "" ? false : true;
    temp.joiningDate = values.joiningDate === "" ? false : true;
    temp.isActive = values.isActive === "" ? false : true;

    setErrors(temp);
    return Object.values(temp).every((x) => x === true);
  };
  const handleSubmit = (e) => {
    e.preventDefault();

    if (validate()) {
      setBtnSubmit(false);
      const formData = new FormData();
      formData.append("designationId", values.designationId);
      formData.append("idNumber", values.idNumber);
      formData.append("staffId", values.staffId);
      formData.append("staffName", values.staffName);
      formData.append("companyId", userCompanyId);
      formData.append(
        "joiningDate",
        moment(values.joiningDate).format("YYYY-MM-DD")
      );
      formData.append("phoneNumber", values.phoneNumber);
      formData.append("email", values.email);
      formData.append("address", values.address || "");
      formData.append("isActive", values.isActive);
      addOrEdit(formData);
    }
  };
  const applicationAPI = () => {
    return {
      create: (newrecord) =>
        axios.post(config.APIACTIVATEURL + config.CREATESTAFF, newrecord, {
          ...headerconfig,
        }),
      update: (updateRecord) =>
        axios.put(config.APIACTIVATEURL + config.UPDATESTAFF, updateRecord, {
          ...headerconfig,
        }),
    };
  };
  const addOrEdit = (formData) => {
    if (formData.get("staffId") === "00000000-0000-0000-0000-000000000000") {
      applicationAPI()
        .create(formData)
        .then((res) => {
          if (res.data.statusCode === 200) {
            handleSuccess(res.data.data);
            resetForm();
            GetData(pageNumber);
            closeAddStaffModal();
            setBtnSubmit(true);
          } else {
            handleError(res.data.data);
            setBtnSubmit(true);
          }
        })
        .catch(function (error) {
          handleError("Error in saving data");
          setBtnSubmit(true);
        });
    } else {
      applicationAPI()
        .update(formData)
        .then((res) => {
          if (res.data.statusCode === 200) {
            handleSuccess(res.data.data);
            resetForm();
            GetData(pageNumber);
            closeAddStaffModal();
            setBtnSubmit(true);
          } else {
            handleError(res.data.data);
            setBtnSubmit(true);
          }
        })
        .catch(function (error) {
          handleError("Error in updating data");
          setBtnSubmit(true);
        });
    }
  };
  const onDelete = (e, id) => {
    if (window.confirm("Are you sure to delete this record?")) {
      axios
        .delete(config.APIACTIVATEURL + config.DELETESTAFF + "/" + id, {
          ...headerconfig,
        })
        .then((response) => {
          if (response.data.statusCode === 200) {
            handleSuccess(response.data.data);
            GetData(pageNumber);
            resetForm();
          } else {
            handleError(response.data.data);
            GetData(pageNumber);
            resetForm();
          }
        });
    }
  };
  const searchStaff = (keyword) => {
    if (keyword === "") {
      GetData(pageNumber);
    } else {
      axios
        .get(
          config.APIACTIVATEURL +
            config.SEARCHSTAFF +
            "?keyword=" +
            keyword +
            "&userId=" +
            userId,
          {
            ...headerconfig,
          }
        )
        .then((response) => {
          setLists(response.data);
        })
        .catch(() => {
          handleError("Error searching data");
        });
    }
  };

  const GetData = (number) => {
    axios
      .get(
        config.APIACTIVATEURL +
          config.GETSTAFFS +
          "?userId=" +
          userId +
          "&pageNumber=" +
          number +
          "&pageSize=" +
          pageSize,
        { ...headerconfig }
      )
      .then((response) => {
        setLists(response.data.data.data);
        setPageNumber(response.data.data.pageNumber);
        setPageSize(response.data.data.pageSize);
        setTotalPages(response.data.data.totalPages);
        setData(response.data.data);
        setTotalRecords(response.data.data.totalRecords);
      });
  };
  const GetDesignations = () => {
    axios
      .get(config.APIACTIVATEURL + config.GETALLDESIGNATIONS, {
        ...headerconfig,
      })
      .then((response) => {
        setDesignations(response.data.data);
      });
  };
  const GetUserData = () => {
    axios
      .get(config.APIACTIVATEURL + config.GETUSERBYID + "/" + userId, {
        ...headerconfig,
      })
      .then((res) => {
        if (res.data.statusCode === 200) {
          setUserCompanyId(res.data.data.companyId);
        }
      });
  };
  const applyErrorClass = (field) =>
    field in errors && errors[field] === false ? " form-control-danger" : "";
  useEffect(() => {
    GetUserData();
    GetDesignations();
  }, []);

  useEffect(() => {
    if (userCompanyId) {
      GetData(pageNumber);
    }
  }, [userCompanyId, pageNumber]);
  return (
    <div id="layout-wrapper">
      <LayoutHeader></LayoutHeader>
      <LayoutSideBar></LayoutSideBar>
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 className="mb-sm-0">STAFFS</h4>
                  <button
                    className="btn btn-primary"
                    onClick={() => setShowAddStaffModal(true)}
                  >
                    Add Staff
                  </button>
                </div>
              </div>
            </div>
            <div className="row mt-6">
              <div className="col-12">
                <div className="p-3 border rounded shadow bg-white">
                  <div className="d-flex align-items-center">
                    <input
                      type="text"
                      className="form-control me-3"
                      style={{ maxWidth: "70%" }}
                      placeholder="Search......."
                      value={searchKeyword}
                      onChange={(e) => {
                        const keyword = e.target.value;
                        setSearchKeyword(keyword);
                        searchStaff(keyword);
                      }}
                    />
                    <button
                      className="btn btn-danger me-2"
                      style={{ width: "120px" }}
                      type="button"
                      onClick={handleClearSearch}
                    >
                      Clear
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <Modal
              show={showAddStaffModal}
              onHide={closeAddStaffModal}
              size="lg"
            >
              <Modal.Header closeButton>
                <Modal.Title>
                  {values.staffId === "00000000-0000-0000-0000-000000000000"
                    ? "Add Staff"
                    : "Edit Staff"}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <form onSubmit={handleSubmit} autoComplete="off" noValidate>
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="mb-3">
                        <label htmlFor="designations" className="form-label">
                          Designation*
                        </label>
                        <select
                          value={values.designationId}
                          name="designationId"
                          onChange={handleInputChange}
                          className={
                            "form-select " + applyErrorClass("designationId")
                          }
                        >
                          <option value="00000000-0000-0000-0000-000000000000">
                            Please select
                          </option>
                          {designations.length > 0 &&
                            designations.map((c) => (
                              <option
                                key={c.designationId}
                                value={c.designationId}
                              >
                                {c.designationName}
                              </option>
                            ))}
                        </select>
                        {errors.designationId === false ? (
                          <div className="validationerror">Please select</div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="mb-3">
                        <label htmlFor="idNumber" className="form-label">
                          ID Number*
                        </label>
                        <input
                          type="text"
                          name="idNumber"
                          value={values.idNumber}
                          onChange={handleInputChange}
                          className={
                            "form-control " + applyErrorClass("idNumber")
                          }
                          placeholder="(e.g-ABC1234567890)"
                          maxLength={15}
                        />
                        {errors.designationId === false ? (
                          <div className="validationerror">
                            Please enter idNumber
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="mb-3">
                        <label htmlFor="staffName" className="form-label">
                          Staff*
                        </label>
                        <input
                          type="text"
                          value={values.staffName}
                          name="staffName"
                          onChange={handleInputChange}
                          className={
                            "form-control " + applyErrorClass("staffName")
                          }
                          placeholder="Please Enter Staff Name"
                        />
                        {errors.staffName === false ? (
                          <div className="validationerror">
                            Please enter staff name{" "}
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="mb-3">
                        <label htmlFor="joiningdate" className="form-label">
                          Joining Date
                        </label>
                        <input
                          type="date"
                          name="joiningDate"
                          value={values.joiningDate}
                          onChange={handleInputChange}
                          className={
                            "form-control " + applyErrorClass("joiningDate")
                          }
                          max={moment().format("YYYY-MM-DD")}
                        />
                        {errors.joiningDate === false ? (
                          <div className="validationerror">
                            Please enter date{" "}
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="mb-3">
                        <label htmlFor="phoneNumber" className="form-label">
                          Phone Number*
                        </label>
                        <input
                          type="text"
                          name="phoneNumber"
                          value={values.phoneNumber}
                          onChange={handleInputChange}
                          className={
                            "form-control " + applyErrorClass("phoneNumber")
                          }
                          placeholder="Please Enter Phone Number"
                          maxLength={15}
                        />
                        {errors.phoneNumber === false ? (
                          <div className="validationerror">
                            Please enter phone number{" "}
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="mb-3">
                        <label htmlFor="email" className="form-label">
                          Email*
                        </label>
                        <input
                          type="email"
                          name="email"
                          value={values.email}
                          onChange={handleInputChange}
                          className={"form-control " + applyErrorClass("email")}
                          placeholder="Please Enter Email"
                        />
                        {errors.email === false ? (
                          <div className="validationerror">
                            Please enter email{" "}
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                    <div className="col-lg-12">
                      <div className="mb-3">
                        <label htmlFor="address" className="form-label">
                          Address
                        </label>
                        <input
                          type="text"
                          value={values.address}
                          name="address"
                          onChange={handleInputChange}
                          className={
                            "form-control " + applyErrorClass("address")
                          }
                          placeholder="Please Enter Address"
                        />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="mb-3">
                        <label htmlFor="status" className="form-label">
                          Status
                        </label>
                        <select
                          name="isActive"
                          value={values.isActive}
                          onChange={handleInputChange}
                          className={
                            "form-select " + applyErrorClass("isActive")
                          }
                        >
                          <option value="">Please Select</option>
                          <option value="true">Active</option>
                          <option value="false">Inactive</option>
                        </select>
                        {errors.isActive === false ? (
                          <div className="validationerror">Please select </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                    <div className="col-lg-12">
                      <div className="d-flex justify-content-end gap-2 mt-4">
                        {btnSubmit ? (
                          <button type="submit" className="btn btn-primary">
                            {values.staffId ===
                            "00000000-0000-0000-0000-000000000000"
                              ? "Submit"
                              : "Update"}
                          </button>
                        ) : (
                          <button
                            type="submit"
                            className="btn btn-primary"
                            disabled
                          >
                            Submit
                          </button>
                        )}
                        <button
                          type="button"
                          className="btn btn-danger"
                          onClick={resetForm}
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </Modal.Body>
            </Modal>
            <div className="row">
              <div className="col-xl-12">
                <div className="card card-height-100">
                  <div className="card-body">
                    <div className="table-responsive table-card">
                      <table className="table align-middle" id="customerTable">
                        <thead className="table-light">
                          <tr>
                            <th>S.No</th>
                            <th>Designation</th>
                            <th>Id Number</th>
                            <th>Staff</th>
                            <th>Phone Number</th>
                            <th>Status</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody className="list form-check-all">
                          {lists.length > 0 ? (
                            lists.map((v, index) => (
                              <tr key={v.staffId}>
                                <td>
                                  {(pageNumber - 1) * pageSize + (index + 1)}
                                </td>
                                <th>{v.designationName}</th>
                                <th>{v.idNumber}</th>
                                <th>{v.staffName}</th>
                                <th>{v.phoneNumber}</th>
                                <td>
                                  <span
                                    className={`badge bg-${
                                      v.isActive ? "success" : "danger"
                                    } text-uppercase`}
                                  >
                                    {v.isActive ? "Active" : "Inactive"}
                                  </span>
                                </td>
                                <td>
                                  <ul className="list-inline hstack gap-2 mb-0">
                                    <li>
                                      <Link
                                        className="edit-item-btn"
                                        onClick={() => showViewDetails(v)}
                                      >
                                        <i className="ri-eye-fill align-bottom text-muted" />
                                      </Link>
                                    </li>
                                    <li>
                                      <Link
                                        className="edit-item-btn"
                                        onClick={() => showEditDetails(v)}
                                      >
                                        <i className="ri-pencil-fill text-muted" />
                                      </Link>
                                    </li>

                                    <li>
                                      <Link
                                        className="remove-item-btn"
                                        onClick={(e) => onDelete(e, v.staffId)}
                                      >
                                        <i className="ri-delete-bin-fill text-muted" />
                                      </Link>
                                    </li>
                                  </ul>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="10" className="text-center">
                                No Data Available
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                    <div className="align-items-center mt-4 pt-2 justify-content-between d-flex">
                      <div className="flex-shrink-0">
                        <div className="text-muted">
                          Showing{" "}
                          <span className="fw-semibold">{lists.length}</span> of{" "}
                          <span className="fw-semibold">{totalRecords}</span>{" "}
                          Results
                        </div>
                      </div>
                      <ul className="pagination pagination-separated pagination-sm mb-0">
                        <li
                          className={`page-item ${
                            pageNumber === 1 ? "disabled" : ""
                          }`}
                          onClick={() => GetPageData(pageNumber - 1)}
                        >
                          <Link className="page-link">Previous</Link>
                        </li>

                        {renderPageNumbers}
                        <li
                          className={`page-item ${
                            pageNumber === totalPages ? "disabled" : ""
                          }`}
                          onClick={() => GetPageData(pageNumber + 1)}
                        >
                          <Link className="page-link">Next</Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal show={showDetailModal} onHide={() => setShowDetailModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Staff Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {staffDetail && (
            <div>
              <p>
                <strong>Designation:</strong> {staffDetail.designationName}
              </p>
              <p>
                <strong>IdNumber:</strong> {staffDetail.idNumber}
              </p>
              <p>
                <strong>Staff Name:</strong> {staffDetail.staffName}
              </p>
              <p>
                <strong>Joining Date:</strong>{" "}
                {moment(staffDetail.joiningDate).format("DD-MMM-YYYY")}
              </p>
              <p>
                <strong>Phone Number:</strong> {staffDetail.phoneNumber}
              </p>
              <p>
                <strong>Email:</strong> {staffDetail.email}
              </p>

              <p>
                <strong>Address:</strong> {staffDetail.address}
              </p>
              <p>
                <strong>IsActive:</strong>{" "}
                {staffDetail.isActive ? "Active" : "Inactive"}
              </p>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={() => setShowDetailModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
